export default "__VITE_ASSET__cVWEx_XZ__"